"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ObjectReference = /** @class */ (function () {
    function ObjectReference(id, label, idFieldName) {
        this.id = id;
        this.label = label;
        this.defineAdditionalIdField(idFieldName);
    }
    ObjectReference.prototype.defineAdditionalIdField = function (idFieldName) {
        var _a;
        if (!idFieldName) {
            return;
        }
        if ("id" === idFieldName) {
            return;
        }
        Object.defineProperties(this, (_a = {},
            _a[idFieldName] = {
                // tslint:disable-next-line: object-literal-shorthand
                get: function () { return this.id; },
                // tslint:disable-next-line: object-literal-shorthand
                set: function (id) { this.id = id; },
                enumerable: true
            },
            _a));
    };
    return ObjectReference;
}());
exports.ObjectReference = ObjectReference;
//# sourceMappingURL=ObjectReference.js.map